var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImageWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 192,
  height: 192,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.9
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.063 26.199a3.464 3.464 0 0 1 3.464-3.465h162.821a3.464 3.464 0 0 1 3.464 3.465v14.723H6.062V26.199Z",
  fill: "#8A8A8A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144 34.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM154.5 34.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM165 34.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6 40.5h168v101.536a3.464 3.464 0 0 1-3.464 3.464H9.464A3.464 3.464 0 0 1 6 142.036V40.5Z",
  fill: "#5E5E5E"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424242",
  d: "M42.438 59.109h97v6.063h-97zM42.438 77.297h97v6.063h-97z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M18.188 48.933a3.464 3.464 0 0 1 3.464-3.464h162.821a3.465 3.465 0 0 1 3.465 3.464v14.723H18.188V48.933Z",
  fill: "#8A8A8A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.625 57c1.674 0 3.031-1.343 3.031-3s-1.357-3-3.031-3c-1.674 0-3.031 1.343-3.031 3s1.357 3 3.031 3ZM168.234 57c1.674 0 3.032-1.343 3.032-3s-1.358-3-3.032-3-3.031 1.343-3.031 3 1.357 3 3.031 3ZM178.844 57c1.674 0 3.031-1.343 3.031-3s-1.357-3-3.031-3c-1.674 0-3.032 1.343-3.032 3s1.358 3 3.032 3ZM18.188 63h169.75v101.536a3.464 3.464 0 0 1-3.465 3.464H21.652a3.464 3.464 0 0 1-3.465-3.464V63Z",
  fill: "#5E5E5E"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424242",
  d: "M54.563 81.844h97v6.063h-97zM54.563 100.031h97v6.063h-97z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#image_warning_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M156.959 138.247h11.367v30.312h-11.367v-30.312Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m192.093 170.348-26.498-45.424a3.74 3.74 0 0 0-1.36-1.36 3.62 3.62 0 0 0-1.893-.533c-.71 0-1.36.178-1.952.533a4.467 4.467 0 0 0-1.36 1.36l-26.498 45.424a5.36 5.36 0 0 0-.414.947A4.12 4.12 0 0 0 132 172.3c0 1.065.375 1.972 1.124 2.721a3.738 3.738 0 0 0 2.661 1.065h53.055c1.064 0 1.951-.355 2.661-1.065.749-.749 1.124-1.656 1.124-2.721 0-.355-.059-.69-.177-1.005a3.398 3.398 0 0 0-.355-.947Zm-25.966-1.833h-7.57v-7.571h7.57v7.571Zm0-11.356h-7.57v-18.927h7.57v18.927Z",
  fill: "#F2C94C"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "image_warning_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(132 120)",
  d: "M0 0h60v60H0z"
})))));
export { SvgImageWarning as ReactComponent };
export default "/87d1319ffbbedc76b03cfe31f871e391.svg";